import WidgetContext from 'embed_v2/components/Context'
import { useContext, useRef } from 'preact/hooks'
import PropTypes from 'prop-types'
import { getStylesFn } from 'core/helpers/styles'
import i18n from 'core/services/i18n'
import { ElementWebinarLinkOptions } from 'core/types/element/element_webinar_link'
import optionsPropTypes from 'PropsSpec'
import Input from './common/Input'

const extractStyles = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'], {
  position: 'relative',
  width: '100%',
  height: '100%'
})
const extractButtonStyles = getStylesFn(['color', 'fontFamily', 'fontWeight'], {
  position: 'absolute',
  top: '50%',
  right: '20px',
  transform: 'translateY(-50%)',
  fontSize: '16px',
  userSelect: 'none',
  cursor: 'pointer',
  transition: 'opacity 90ms ease-in-out'
})

type Props = {
  options: ElementWebinarLinkOptions
}

const WebinarLink = (props: Props) => {
  const { thankYouData } = useContext(WidgetContext)
  const copyNode = useRef<HTMLDivElement>(null)
  const styles = extractStyles(props.options)
  const buttonStyles = {
    ...extractButtonStyles(props.options.copy_button),
    right: `${10 + props.options.padding_right}px`
  }
  const joinUrl = thankYouData ? thankYouData.join_url : ''

  const onCopy = () => {
    if (!copyNode.current) return

    copyNode.current.style.opacity = '0.8'
    navigator.clipboard.writeText(joinUrl)

    setTimeout(() => {
      if (copyNode.current) {
        copyNode.current.style.opacity = '1'
      }
    }, 1000)
  }

  return (
    <div className="wf_reset" style={styles}>
      <Input
        value={joinUrl}
        options={props.options}
        onChange={() => {}}
        readOnly
        placeholder="Link"
        name="webinar_link"
        rightButton
      />
      <div ref={copyNode} onClick={onCopy} style={buttonStyles}>
        {i18n.t('layout.copy')}
      </div>
    </div>
  )
}

WebinarLink.propTypes = {
  options: optionsPropTypes('webinar_link'),
  label: PropTypes.string
}

export default WebinarLink
